//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Service from '@/service/chat'
import Pagination from '@/common/mixins/pagination'
import AudioMsg from '../chat/_audio_msg'
import LocationMsg from '../chat/_location_msg'
import WX_API from '@/utils/wx_api'
const handleSysMsg = (item) => {
    if (item.msg_ext) {
        item.msg_ext.headimg = 'https://cdn.vip-wifi.com/fangchan/img/personal_center/notice/cdfx_register.png'
        item.msg_ext.nickName = '系统消息'
    }
}
export default {
    mixins: [
        Pagination
    ],
    data () {
        return {
            show_list: false,
            chart_pos: '',
            loading: false,
            per: 20
        }
    },
    mounted () {
        this.no_reach_bottom = true
        this.getData()
    },
    methods: {
        copyContent (e) {
            WX_API.setClipboardData(e.currentTarget.dataset.content)
        },
        previewImg (e) {
            const { img } = e.currentTarget.dataset
            const current = img.replace(/132$/, 0)
            wx.previewImage({
                current,
                urls: [current]
            })
        },
        getMore () {
            if (!this.loading && !this.no_more) {
                this.page++
                this.getData()
            }
        },
        getData () {
            if (this.loading) {
                return
            }
            const { id } = this.$route.query
            this.loading = true
            let last_id = ''
            if (this.items && this.items.length) {
                last_id = this.items[0].pos_id
            }
            Service.getHistoryChat(id, this.page, this.per).then((data) => {
                data.items.forEach((item) => {
                    item.created_time_str = item.created_time.replace(/-/g, '/')
                    const { msg_ext } = item
                    item.pos_id = `${item.role}-${new Date(item.created_time_str).getTime()}`
                    if (msg_ext) {
                        if (msg_ext.msgStyle === 'sys_tips') {
                            handleSysMsg(msg_ext)
                        } else if (['img', 'location', 'audio'].indexOf(msg_ext.msgStyle) > -1) {
                            item.msg_content = `[${
                                {
                                    'img': '图片',
                                    'location': '定位',
                                    'audio': '语音'
                                }[msg_ext.msgStyle]}]`
                        }

                    }
                })
                this.handleData(data)
                this.items = this.items.sort((a, b) => {
                    return new Date(a.created_time_str).getTime() - new Date(b.created_time_str).getTime()
                })
                if (this.page === 1) {
                    this.$nextTick(() => {
                        this.chart_pos = 'msg-btm'
                        this.show_list = true
                    })
                } else {
                    this.$nextTick(() => {
                        console.error('last_id', last_id)
                        this.chart_pos = last_id
                    })
                }
            })
        }
    },
    components: {
        AudioMsg,
        LocationMsg
    }
}
